import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { GlobalService } from '../global.service';
import { ModalController, LoadingController, Events } from '@ionic/angular';
import { ModalSelectPage } from '../modal-select/modal-select.page';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.page.html',
  styleUrls: ['./stats.page.scss'],
})
export class StatsPage implements OnInit {

    ismodal = false;
    allocationMethods = GlobalService.StatAllocationMethods;
    stats = GlobalService.Stats;
    character = GlobalService.CHARACTER;
    allocationMethod = null;
    statPointsInput = 0;
    constructor(private router: Router, private globalService: GlobalService, private modalController: ModalController) { }

    ngOnInit() {
        var n = false;
        if (this.allocationMethod == null) {
            this.allocationMethod = this.getAllocationMethod();

            
            
                //this.distributeMinValues();
                //this.rollStats();

            
        }
        
        //this.allocationChanged();
  }
    close() {
        this.modalController.dismiss();
    }
    allocationChanged() {
        var newalloc = this.getAllocationMethod();
        
        if (this.allocationMethod == null || newalloc.name != this.allocationMethod.name) {
            this.allocationMethod = newalloc
            if (this.allocationMethod != null) {
                GlobalService.ResetStats();
                this.character.statDice = [];
                this.character.statPoints = 0;
                this.character.statPointsAllocation = 0;
                if (this.allocationMethod.points > 0) {
                    this.character.statPoints = this.allocationMethod.points;
                    this.character.statPointsAllocation = this.allocationMethod.points;
                    this.distributeMinValues();
                }
                if (this.allocationMethod.buttontext != "") {
                    this.rollStats();
                }
                if (this.allocationMethod.input) {
                    this.statPointsInput = 50;
                    this.setPoints(this.statPointsInput);
                }

            }
        }
    }
    distributeMinValues() {
        for (var i=0; i < GlobalService.Stats.length; i++)
        {
            var minvalue = 2;
            var statname = GlobalService.Stats[i];
            if (this.character.statPoints >= minvalue) {
                this.character.stats[statname].value = minvalue;
                this.character.statPoints -= 2;
            }
        }
    }
    getAllocationMethod() {
        var m = this.character.statAllocation;
        var method = this.allocationMethods.filter(e => { return e.name == m; });
        if (method.length > 0) {
            return method[0];
        }
        return null;
    }
    allocationDescription() {
        var m = this.character.statAllocation;
        var method = this.allocationMethods.filter(e => { return e.name == m; });
        if (method.length > 0) {
            return method[0].description;
        }

        return "---";
    }

    rollStats() {
        switch (this.allocationMethod.name) {
            case "Random":
                this.rollRandom();
                break;
            case "Fast":
                this.rollFast();
                break;
        }
    }
    rollRandom() {
        var points = 0;
        for (var i = 0; i < 10; i++) {
            var r = GlobalService.Roll(10);
            
            points += r;
        }
        if (points < 20) { points = 20;}
        this.character.statPoints = points;
        this.character.statPointsAllocation = points;
        this.distributeMinValues();
    }
    rollFast() {
        this.character.statDice = [];
        for (var i = 0; i < 10; i++) {
            var r = GlobalService.Roll(8)+2;

            this.character.statDice.push({ value: r, used: false });
        }
    }
    setPoints(amount) {
        if (amount < 20) {
            amount = 20;
            this.statPointsInput = amount;
            this.globalService.toast("Minimum of 20");
        }
        this.character.statPoints = amount;
        this.character.statPointsAllocation = amount;
        this.distributeMinValues();
    }
    change(statname, dir) {
        
        if (dir > 0) {
            if (this.character.statPoints > 0) {
                this.character.stats[statname].value++;
                this.character.statPoints--;
            }
        }
        else {
            if (this.character.statPoints < this.character.statPointsAllocation) {
                this.character.stats[statname].value--;
                this.character.statPoints++;
            }
        }

    }
    relocate(statname) {
        var value = this.character.stats[statname].value;
        var items = this.character.statDice.filter(e => { return e.used });
        for (var i=0; i < items.length; i++) {
            if (items[i].value == value) {
                items[i].used = false;
                this.character.stats[statname].set = false;
                this.character.stats[statname].value = 0;
                break;
            }
        }
    }
    async allocate(statname) {
        var items = this.character.statDice.filter(e => { return !e.used });
        var values = items.map(e => { return e.value });
        const modal = await this.modalController.create({
            component: ModalSelectPage,
            componentProps: { items: values, title: "Allocate to " + statname, freeinput:false }
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data) {
            console.log(data, items);
            items[data.idx].used = true;
            this.character.stats[statname].set = true;
            this.character.stats[statname].value = data.value;
        }
    }



}
